import type { ReactNode } from 'react';
import classnames from 'classnames';
import { useEffect } from 'react';

interface IPageWrapperProps {
    children: ReactNode;
    className?: string;
    fullHeight?: boolean;
    scrollToTopUpdater?: string | number;
}

export function PageWrapper(props: IPageWrapperProps) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [props.scrollToTopUpdater]);

    return (
        <div className={classnames('page-wrapper', props.className || '', { 'is-full-height': props.fullHeight })}>
            {props.children}
        </div>
    );
}
